// File: FormINC20A.jsx
import React from "react";

export default function FormINC20A() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Form INC-20A
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists in filing Form INC-20A for commencement of business.
          </p>
          <p className="text-gray-700">
            Complete INC-20A declaration filing within 180 days of incorporation, subscriber share payment verification, bank statement attachment, director declaration, MCA portal submission, and Certificate of Commencement issuance for legal business operations.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Form INC-20A MCA commencement certificate) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184296/pexels-photo-3184296.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Form INC-20A commencement of business certificate"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation preparation for seamless INC-20A MCA filing.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Proof of subscription money receipt (bank statements)</li>
                <li>Certificate of Incorporation</li>
                <li>Director's DSC and DIN details</li>
                <li>Board resolution for commencement</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Timely and correct MCA filing ensuring legal business commencement without penalties.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  180-Day Compliance Mastery
                </h3>
                <p className="text-gray-700 text-sm">
                  Guaranteed filing within mandatory 180-day window from incorporation date, complete subscriber share payment verification through bank statements/RTGS proofs, director declaration preparation, MCA V3 portal submission with DSC, ensuring zero delays and penalty avoidance.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Penalty Prevention Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Prevents ₹50,000 company penalty + ₹1,000/day officer fines (max ₹1 lakh), ensures borrowing powers activation, eliminates business operation restrictions, guarantees Certificate of Commencement issuance, and maintains active MCA status preventing strike-off proceedings.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Seamless MCA Portal Execution
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end MCA compliance from bank statement attachment, subscriber verification, registered office coordinates entry, director certification, e-form validation, SRN generation, payment processing, to Certificate issuance enabling legal contracts, banking, GST registration, and full business operations.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
